export default __webpack_public_path__ + "static/media/wrzos_cien.39370e02.svg";